import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-brand-lightBlue rounded-2xl overflow-hidden" data-id="element-181">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-brand-lightBlue/80 transition-colors" data-id="element-182">
        <span className="font-bold text-brand-navy" data-id="element-183">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-184">
          <ChevronDown className="w-5 h-5 text-brand-navy" data-id="element-185" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-186">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-187">
            <div className="px-6 pb-4 text-brand-navy" data-id="element-188">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}